import { Array } from '@common/Array/Array'

import { baseGlobals } from '@root/typescript/baseGlobals'

import type Sprite from '../Sprite/Sprite'

type TSprites = Sprite[]

export default class SpriteEngine {
  public static spriteCount = 0

  public canDebug = false
  protected items: TSprites = []

  /**
   * Sprite-ok hozzáadása.
   * @param items - Spriteok tömbben.
   */
  public add (...items: Sprite[]): void {
    const { spriteCount } = SpriteEngine

    SpriteEngine.spriteCount = spriteCount + items.length

    this.items.push(...items)
  }

  /** Sprite-ok törlése. */
  public clear (): void {
    const { spriteCount } = SpriteEngine

    SpriteEngine.spriteCount = spriteCount - this.items.length

    this.items = []
  }

  /**
   * Kirajzolásért felelős függvény.
   * @param ctx - Biztosítja a 2D renderelési kontextust egy <canvas> elem rajzfelületéhez.
   */
  public render (ctx: CanvasRenderingContext2D): void {
    this.onRender(ctx)
  }

  /**
   * Frissítés.
   * Sima sprite-nál nincs mit updatelni, ezt majd felülcsaphatjuk a leszármazottakban.
   * @param deltaTime - Frissítések gyakorisága.
   */
  public update (deltaTime: number): void {
    this.onUpdate(deltaTime)
  }

  /** Berendezi a sprite-okat a Z attribútumuk alapján, hogy renderelésnél jól takarják egymást. */
  public orderByZ (): void {
    const newItems = Array.sort(this.items, (a, b) => (a.getZ() - b.getZ()))

    this.items = newItems
  }

  /**
   * Update overrider.
   * @param deltaTime - Frissítések gyakorisága.
   */
  protected onUpdate (deltaTime: number): void {
    this.items.forEach((item) => {
      item.update(deltaTime)
    })
  }

  /**
   * Render overrider.
   * @param ctx - Biztosítja a 2D renderelési kontextust egy <canvas> elem rajzfelületéhez.
   */
  protected onRender (ctx: CanvasRenderingContext2D): void {
    this.items.forEach((item) => {
      item.render(ctx)

      if (baseGlobals.isDev && this.canDebug) {
        item.debug(ctx)
      }
    })
  }
}
